import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { sendWelcomeEmail } from "../queryFunctions/sendWelcomeEmail";

export function useSendWelcomeEmail(
  options: UseMutationOptions<void, unknown, { patientId: string }> = {},
) {
  return useMutation({ ...options, mutationFn: sendWelcomeEmail });
}
